import Vue from 'vue';

Vue.directive('slugify', {
    bind: function(el: any, binding: any, vnode: any)
    {
        let search = [" ", "ę", "ó", "ą", "ś", "ł", "ż", "ź", "ć", "ń"];
        let replace = ["-", "e", "o", "a", "s", "l", "z", "z", "c", "n"];

        el.slugify = function(value: string)
        {
            let text = value.toLowerCase();

            for (var i = 0; i < search.length; i++)
            {
                let re = new RegExp(search[i], "g");
                text = text.replace(re, replace[i]);
            }

            return text.replace(/[^a-z0-9-]/g, "");
        };

        el.addEventListener('blur', function(e: any)
        {
            e.target.value = el.slugify(e.target.value);
            e.target.dispatchEvent(new Event('input', { bubbles: true }));
        });
    }
});

Vue.directive('required', {
    bind: function(el: any, binding: any, vnode: any)
    {
        el.querySelector('legend').insertAdjacentHTML("beforeend", " <var>*</var>");
    }
});

Vue.directive('focus', {
    inserted: function(el: any)
    {
        el.focus();
    }
});
